export default __webpack_public_path__ + "static/media/event-management.eca5da46.jpg";